import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./cloudInsights.scss";
import hero from "../../../asset/image/Socicons-login-signup.svg";
import CloudInsight from "../../../asset/image/Cloudinsights.svg";
import CloudSocial from "../../../asset/image/CloudSocialLogo.svg";
// import card1 from "../../../asset/image/Group 1923.svg";
import { Card } from "react-bootstrap";
import { HashLink as Link } from "react-router-hash-link";
import { Helmet } from "react-helmet";
import Youtube from "@material-ui/icons/YouTube";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import pricingImage from "../../../asset/image/Group 1924.svg";
import cloudInsightWork from "../../../asset/image/Group 1923.svg";

function CloudInsights() {
  const [show, setShow] = useState(false);
  const [video, setVideo] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  return (
    <div>
      <Helmet>
        <meta
          charSet="utf-8"
          name="Cloudsocial : CloudInsight for Brief data search"
        />
        <meta
          name="description"
          content="Cloudinsight helps to get comprehensive data coverage of news, blogs, discussions and reviews. Crawl for insights with Boolean search queries sign up now to get started."
        />
        <title>CloudInsights</title>
        <link rel="canonical" href="https://cloudsocial.io/cloud-insights" />
      </Helmet>
      <div className="InsightsMainContainer">
        <h1 className="heading mt-1">CloudInsights</h1>
        <h6 className="sub-heading">
          Crawl for insights with Boolean search queries
        </h6>

        <div className="insightsButtonContainer mt-4">
          {/* <Link to="#work"> */}
          {/* </Link> */}

          <div onClick={handleShow} style={{ alignItems: "center" }}>
            <InsightsButton
              bgcolor="#FFFFFF"
              width="247px"
              height="46px"
              borderRadius="8px"
              borderColor="#859DB6"
              color="#2F2F43"
              fontSize="16px"
              marginBottom="10px"
              alignItems="center"
              // id="#calender"
              padding="0px"
            >
              <Youtube style={{ color: "red" }} />
              &nbsp; See how it works
            </InsightsButton>
          </div>
          <Modal
            size="xl"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header className="modelHeader" closeButton>
              <img src={CloudSocial} alt="CloudSocial" className="modalLogo" />
            </Modal.Header>
            <Modal.Body className="model-body">
              <div
                className="video"
                style={{
                  position: "relative",
                  paddingBottom: "56.25%",
                  paddingTop: "25",
                  height: "0",
                  wrapAround: true,
                  cursor: "pointer",
                  freeScroll: true,
                }}
              >
                <iframe
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  // src="https://www.youtube.com/embed/mirBoqH4Yas?autoplay=1&mute=1"
                  src="https://www.youtube.com/embed/X74AzU2XLmc?autoplay=1&mute=1"
                  frameBorder="0"
                  title="CloudSocial"
                />
              </div>
            </Modal.Body>
          </Modal>
          <InsightsButton
            bgcolor="#6D6EF3"
            width="220px"
            height="46px"
            borderRadius="8px"
            fontSize="16px"
            href="https://ciapp.cloudsocial.io/account/login"
            target="_blank"
            rel="noopener noreferrer"
            id="myHeader"
            marginBottom="10px"
          >
            Get Started
          </InsightsButton>
        </div>
        <div id="work">
          <img
            src={hero}
            alt="CloudInsights"
            // height="500px"
            // width="800px"
            className="heroImage"
          />
        </div>
        <div className="cardAlignment mb-5">
          <div className="insightsCard1 ">
            <h2 className="ml-4" style={{ fontWeight: 600, color: "#232355" }}>
              How it <br></br>works
            </h2>
            <div className="worksCardDetails">
              <div>
                <img
                  src={cloudInsightWork}
                  alt="pricing"
                  width="180px"
                  height="180px"
                />
              </div>

              {/* <div style={{ textAlign: "center" }}>
              <div
                style={{
                  borderRadius: "25px",
                  backgroundColor: "#232355",
                  height: "185px",
                  width: "185px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h2 className=" " style={{ fontWeight: 600, color: "white" }}>
                  How it <br></br>works
                </h2>
              </div>
             </div> */}
              <div className="workFeeds">
                <div className="workCard1">
                  <div className="workData1 ">
                    <div className="workSubTitle mb-2">Our data feeds</div>
                    <ul className="workDetails">
                      <li>News sites</li>
                      <li>Blogs</li>
                      <li>Online discussions</li>
                      <li>Review sites</li>
                    </ul>
                  </div>
                  <div className="workData1">
                    <div className="workSubTitle mb-2 ">How to put data to</div>
                    <ul className="workDetails">
                      <li className="dataFeeds">
                        Analyze by persons /locations /organization
                      </li>
                      <li>Sentiment</li>

                      <li>Competition</li>
                      <li>Granular filtering</li>
                    </ul>
                  </div>
                  <div className="workData1 ">
                    <div className="workSubTitle mb-2 ">How to get started</div>
                    <ul className="workDetails">
                      <li className="dataFeeds ">
                        Signup by clicking on Get Started button &nbsp;
                        <InsightsButton
                          bgcolor="#33A5F1"
                          borderRadius="7px"
                          fontSize="14px"
                          href="https://ciapp.cloudsocial.io/account/login"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginLeft: "10px" }}
                        >
                          Get Started
                        </InsightsButton>
                      </li>

                      <li>Select the relevant plan basis the search results</li>
                      <li>Make payment & start using</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="cardAlignment mb-5">
          <div className="insightsCard1 ">
            <h2 className="ml-3" style={{ fontWeight: 600, color: "#232355" }}>
              Pricing
            </h2>
            <div className="worksCardDetails">
              <div>
                <img
                  src={pricingImage}
                  alt="pricing"
                  width="180px"
                  height="180px"
                />
              </div>
              <div className="workFeeds">
                <div className="" style={{ display: "flex" }}>
                  <div className="col-12 col-md-6 p-0">
                    <div className="workSubTitle mb-2">Open Web Data Feeds</div>
                    <div className="workDetails mb-2">
                      Get comprehensive data coverage of news, blogs,
                      discussions and reviews
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <InsightsButton
                        bgcolor="#33A5F1"
                        borderRadius="7px"
                        className="mt-2 mb-2"
                        fontSize="14px"
                        href="https://ciapp.cloudsocial.io/account/login"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Get Started Now
                      </InsightsButton>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 p-0">
                    <ul className="workDetails mt-4">
                      <li>Enterprise Level Global Coverage</li>
                      <li>Real-Time Monitoring</li>
                      <li>
                        Structured Data (Title, Body, Author, Date, Comments,
                        Language)
                      </li>
                      <li>Engagement Metrics (Social Signal, Virtual Score)</li>
                      <li>Sentiment & Entity Recognition</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="cardAlignment mb-5">
          <div className="insightsCard1 ">
            <h2 className="ml-3" style={{ fontWeight: 600, color: "#232355" }}>
              Pricing
            </h2>
            <div className="worksCardDetails">
              <div>
                <img
                  src={pricingImage}
                  alt="pricing"
                  width="180px"
                  height="180px"
                />
              </div>
              {/* <div className="priceTag">
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    borderRadius: "25px",
                    backgroundColor: "#232355",
                    height: "185px",
                    width: "185px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <h2 className=" " style={{ fontWeight: 600, color: "white" }}>
                    Pricing
                  </h2>
                </div>
              </div>
            </div> */}

              <div className=" workFeeds ">
                <div className="workCard1 ">
                  <div className=" col-md-12 col-lg-12  col-xl-6 p-0">
                    <div className="workSubTitle mb-2">Open Web Data Feeds</div>
                    <div className="workDetails mb-2">
                      Get comprehensive data coverage of news, blogs,
                      discussions and reviews
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <InsightsButton
                        bgcolor="#33A5F1"
                        borderRadius="7px"
                        className="mt-2 mb-2"
                        fontSize="14px"
                        href="https://ciapp.cloudsocial.io/account/login"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Get Started Now
                        {/* <br></br>
                        <span className="trial-subtitle">
                          Pricing Start from &#8377; 1 per mention
                        </span> */}
                      </InsightsButton>
                    </div>
                  </div>

                  <div className="col-md-12 col-lg-6  col-xl-5 p-0">
                    <ul className="workDetails mt-4">
                      <li>Enterprise Level Global Coverage</li>
                      <li>Real-Time Monitoring</li>
                      <li>
                        Structured Data (Title, Body, Author, Date, Comments,
                        Language)
                      </li>
                      <li>Engagement Metrics (Social Signal, Virtual Score)</li>
                      <li>Sentiment & Entity Recognition</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div
          className="cardAlignment mb-5"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card className="insightCard">
             <Card.Img
            variant="top"
            src={CloudInsights}
            alt="Card image cap"
            width="200px"
            height="200px"
          /> 
            <Card.Body>
              <Card.Title className="insightCardBody">
                Open Web Data Feeds
              </Card.Title>
              <Card.Text className="insightCardTitle">
                Get comprehensive data coverage of news, blogs, discussions and
                reviews
              </Card.Text>
              <br />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InsightsButton
                  bgcolor="#33A5F1"
                  borderRadius="7px"
                  className="mt-2 mb-2"
                  fontSize="14px"
                  href="https://ciapp.cloudsocial.io/account/login"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get Started Now
                  <br></br>
                  <span className="trial-subtitle">
                    Pricing Start from &#8377; 1 per mention
                  </span>
                </InsightsButton>
              </div>
              <ul className="insightCardDetails mt-3">
                <li>Enterprise Level Global Coverage</li>
                <li>Real-Time Monitoring</li>
                <li>
                  Structured Data (Title, Body, Author, Date, Comments,
                  Language)
                </li>
                <li>Engagement Metrics (Social Signal, Virtual Score)</li>
                <li>Sentiment & Entity Recognition</li>
              </ul>
            </Card.Body>
          </Card>
        </div> */}
      </div>
    </div>
  );
}
export default CloudInsights;

export const InsightsButton = (props) => {
  return (
    <>
      <a href={props.href} target={props.target} rel={props.rel}>
        <Button
          style={{
            backgroundColor: props.bgcolor,
            border: `1px solid ${props.borderColor}`,
            borderRadius: props.borderRadius,
            width: props.width,
            height: props.height,
            color: props.color,
            fontSize: props.fontSize,
            fontFamily: "Montserrat",
            fontWeight: "600",
            marginBottom: props.marginBottom,
            filter: props.filter,
            alignItems: props.alignItems,
            padding: props.padding,
          }}
        >
          {props.children}
        </Button>
      </a>
    </>
  );
};
